import React from "react";

const SvgIcnSettingUser = props => (
  <svg
    id="icn_setting_user_svg__\u30EC\u30A4\u30E4\u30FC_1"
    data-name="\u30EC\u30A4\u30E4\u30FC 1"
    width={24}
    height={24}
    {...props}
  >
    <defs>
      <style>
        {".icn_setting_user_svg__cls-1{fill:#4d4d4d;fill-rule:evenodd}"}
      </style>
    </defs>
    <path
      className="icn_setting_user_svg__cls-1"
      d="M19.27 6.53a3.64 3.64 0 0 1-7.27 0 3.64 3.64 0 1 1 7.27 0zM15.64 11a5.38 5.38 0 0 0-1.14.12l.44.44-.71 1.29 1.41.4v3.67l-1.41.41.71 1.28-2 2a10.35 10.35 0 0 0 2.73.36A8.62 8.62 0 0 0 22 18.59c-.07-4.2-2.89-7.59-6.36-7.59z"
    />
    <path
      d="M13 15v-1l-1.67-.48a3.86 3.86 0 0 0-.42-1l.84-1.52-.75-.74-1.53.85a3.86 3.86 0 0 0-1-.42L8 9H7l-.48 1.67a3.86 3.86 0 0 0-1 .42L4 10.26l-.75.74.84 1.52a3.86 3.86 0 0 0-.42 1L2 14v1l1.67.48a3.86 3.86 0 0 0 .42 1L3.25 18l.72.73 1.53-.84a4.2 4.2 0 0 0 1 .41L7 20h1l.48-1.68a4.2 4.2 0 0 0 1-.41l1.53.84.72-.73-.84-1.52a3.86 3.86 0 0 0 .42-1zm-4 1a2.1 2.1 0 1 1 0-3 2.11 2.11 0 0 1 0 3z"
      fill="#4d4d4d"
    />
  </svg>
);

export default SvgIcnSettingUser;
